import { useParams } from "react-router";
import Form from "../../form/retur/FormRetur";
import { MainPadding } from "../../../../styles/Main.styles";
import { useGetReturDetail } from "../../api/invoice/retur/resolver";
import { Box, Typography } from "@mui/material";
import Spinner from "../../../../components/spinner/Spinner";

export default function CreationRetur() {
  const { idRetur } = useParams();
  const { data: dataRawRetur, isLoading } = useGetReturDetail({
    return_invoice_id: idRetur,
  });
  const dataRetur = dataRawRetur?.data.data;

  if (idRetur && isLoading) {
    return (
      <MainPadding>
        <Spinner />
      </MainPadding>
    );
  }

  if (dataRetur === undefined) {
    return (
      <MainPadding>
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          height={"100%"}
        >
          <Typography>Data Retur Tidak Ditemukan</Typography>
        </Box>
      </MainPadding>
    );
  }

  return (
    <MainPadding>
      <Form dataRetur={dataRetur} />
    </MainPadding>
  );
}
